import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { MyOrdersStoreService } from '@usf/ngrx-order';
import { MyOrdersTracingService } from 'src/app/my-orders/tracking/tracing/my-orders-tracing.service';
import { OrderExceptionService } from '@order/pages/order-exceptions/service/order-exception.service';
import { DisplayType } from 'src/app/shared/constants/order-status-title.enum';
import { NavigationHelperService } from 'src/app/shared/helpers/navigation.helpers.service';
import { MessageHandlerService } from 'src/app/shared/services/message/message-handler.service';
import { OrderSubmittedAnalyticsService } from 'src/app/order/pages/order-submitted/tracking/analytics/order-submitted-analytics.service';
import { OrderStatus } from '@usf/ngrx-order';
import { ModalService } from '@shared/services/modal/modal.service';
import { OrderService } from '@order/services/order.service';
import { OrderTracingService } from '@order/tracking/tracing/order-tracing.service';
import { OrdersListComponent } from '@order/components/orders-list/orders-list-base.component';

@Component({
  selector: 'app-imported-orders-list-tablet',
  templateUrl: './imported-orders-list-tablet.component.html',
  styleUrls: ['./imported-orders-list-tablet.component.scss'],
})
export class ImportedOrdersListTabletComponent extends OrdersListComponent {
  DisplayType = DisplayType;
  OrderStatus = OrderStatus;
  constructor(
    myOrdersStoreService: MyOrdersStoreService,
    orderService: OrderService,
    router: Router,
    platformService: PlatformService,
    orderExceptionService: OrderExceptionService,
    navigationHelperService: NavigationHelperService,
    popoverController: PopoverController,
    messageHandlerService: MessageHandlerService,
    panAppState: PanAppState,
    myOrdersTracingService: MyOrdersTracingService,
    orderTracingService: OrderTracingService,
    orderSubmittedAnalyticsService: OrderSubmittedAnalyticsService,
    modalService: ModalService,
    modalController: ModalController,
  ) {
    super(
      myOrdersStoreService,
      orderService,
      router,
      platformService,
      orderExceptionService,
      navigationHelperService,
      popoverController,
      messageHandlerService,
      panAppState,
      myOrdersTracingService,
      orderTracingService,
      orderSubmittedAnalyticsService,
      modalService,
      modalController,
    );
  }
}
